var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('Button',{staticClass:"product-button-lightbox",attrs:{"color":"grey","size":"s","icon":"eye"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.open.apply(null, arguments)}}}),(_vm.displayPopin)?_c('ProductLightbox',{ref:"lightbox",attrs:{"product":_vm.product}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }